import { Dispatch } from 'vuex';
import occupancy from '@/store/events/occupancy';

export default {
	namespaced: true,
	modules: { occupancy },
	actions: {
		cleanAllEvents({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('occupancy/cleanAllOccupancies');
		},
	},
};
